import { PitchListExtType } from './pitches.enums';

export enum TrainedStatus {
  Precision = 'Precision',
  Trained = 'Trained',
  Untrained = 'Untrained',
}

export enum PitchListDialog {
  // confirm
  DeleteList = 'DeleteList',
  DeletePitches = 'DeletePitches',
  ResetList = 'ResetList',

  // list
  CopyList = 'CopyList',
  EditList = 'EditList',
  Card = 'Card',
  RenameFolder = 'RenameFolder',

  // selected pitch
  Data = 'Data',
  Edit = 'Edit',
  EditBreaks = 'EditBreaks',
  EditSpins = 'EditSpins',
  Optimize = 'Optimize',

  // manage pitches
  ChangeVideo = 'ChangeVideo',
  Copy = 'Copy',
  Reset = 'Reset',
  Training = 'Training',

  // misc
  Search = 'Search',
}

export enum PitchListOwner {
  None = '',
  Team = 'teams',
  Machine = 'team-machines',
  User = 'team-users',
}

export type PitchListCategory = PitchListOwner | PitchListExtType;
